const backgroundColors = [
    "bg-primary-color",
    "bg-sky-500",
    "bg-rose-300",
    "bg-green-100",
    "bg-orange-500",
    "bg-lime-600",
    "bg-amber-300",
    "bg-emerald-300",
    "bg-teal-600",
    "bg-cyan-400",
    "bg-blue-400",
    "bg-indigo-300",
    "bg-slate-400",
    "bg-red-500",
    "bg-pink-500",
    "bg-purple-500",
    "bg-yellow-500",
    "bg-green-500",
    "bg-blue-500",
    "bg-indigo-500",
    "bg-violet-500",
    "bg-fuchsia-500",
    "bg-rose-500",
    "bg-amber-500",
    "bg-lime-500",
    "bg-teal-500",
    "bg-emerald-500",
    "bg-orange-300",
    "bg-lime-300",
    "bg-amber-400",
    "bg-emerald-400",
    "bg-teal-400",
    "bg-cyan-500",
    "bg-blue-300",
    "bg-indigo-400",
    "bg-slate-300",
    "bg-red-300",
    "bg-pink-300",
    "bg-purple-300",
    "bg-yellow-300",
    "bg-green-300",
    "bg-violet-300",
    "bg-fuchsia-300",
    "bg-rose-600",
    "bg-amber-600",
    "bg-lime-600",
    "bg-teal-600",
    "bg-emerald-600",
    "bg-orange-400",
    "bg-lime-400",
    "bg-amber-500",
    "bg-emerald-500",
    "bg-teal-500",
    "bg-cyan-600",
    "bg-blue-400",
    "bg-indigo-500",
    "bg-slate-500",
    "bg-red-400",
    "bg-pink-400",
    "bg-purple-400",
    "bg-yellow-400",
    "bg-green-400",
    "bg-violet-400",
    "bg-fuchsia-400",
    "bg-rose-700",
    "bg-amber-700",
    "bg-lime-700",
    "bg-teal-700",
    "bg-emerald-700",
    "bg-orange-500",
    "bg-lime-500",
    "bg-amber-600",
    "bg-emerald-600",
    "bg-teal-600",
    "bg-cyan-700",
    "bg-blue-500",
    "bg-indigo-600",
    "bg-slate-600",
    "bg-red-500",
    "bg-pink-500",
    "bg-purple-500",
    "bg-yellow-500",
    "bg-green-500",
    "bg-violet-500",
    "bg-fuchsia-500"
];

export const getRandomColor = () => {
    return backgroundColors[Math.floor(Math.random() * backgroundColors.length)];
};

export default backgroundColors;
